// extracted by mini-css-extract-plugin
export default {"infoLayout":"Inventory_infoLayout__7V-hN","infoSidebar":"Inventory_infoSidebar__ovI8Y","infoMain":"Inventory_infoMain__KyT79"};